import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const AuthStyles: moduleStyleType = {
    loadingWrapper: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',

        '.MuiTypography-root': {
            mb: 2,
        },
    },
}
